import React, { useEffect, useState } from 'react'
import { TbCheck, TbLoader, TbRefresh } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom'
import { appRoute } from '~/routes/routes'
import logoImg from '~/assets/img/gpaLogo.png'

export function CheckoutSuccess() {
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(15)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex flex-col items-center justify-center w-full min-h-screen bg-gpa-gray-50 px-4">
      <div className="flex flex-col items-center bg-white p-10 rounded-lg shadow-md max-w-lg w-full text-center">
        <img src={logoImg} alt="GPA Logo" className="mb-8 w-32" />

        <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-6 text-gpa-blue-500">
          <TbCheck size={32} />
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">Aguardando seu pagamento.</h1>
        <p className="text-gray-600 mb-8 leading-relaxed">
          Seu pedido foi recebido com sucesso na Kiwify! Estamos processando o seu pagamento e ativando a sua assinatura. 
          Isso geralmente leva apenas alguns segundos.
        </p>

        <div className="bg-orange-50 border border-orange-100 p-4 rounded-md mb-8 w-full text-left flex items-start gap-3">
          <TbLoader className="animate-spin text-orange-500 mt-1 flex-shrink-0" size={20} />
          <p className="text-sm text-orange-800">
            <strong>O que fazer agora?</strong> Acesse o seu painel. Assim que o pagamento for confirmado, seu acesso será liberado automaticamente. Você pode precisar recarregar a página do painel.
          </p>
        </div>

        <button
          onClick={() => navigate(appRoute)}
          className="flex items-center justify-center gap-2 w-full bg-gpa-blue-500 hover:bg-gpa-blue-600 text-white font-semibold py-3 px-6 rounded-md transition-colors"
        >
          Ir para o Painel <TbRefresh size={18} />
        </button>

        <p className="text-xs text-gray-400 mt-4">
          Você será redirecionado em {countdown} segundos...
        </p>
      </div>
    </div>
  )
}
